{
  "ascending": "crescente",
  "ascendingSort": "classificado pela coluna {columnName} em ordem crescente",
  "descending": "decrescente",
  "descendingSort": "classificado pela coluna {columnName} em ordem decrescente",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "coluna classificável"
}
